import type { BillingCycle } from './BillingCycle';

export class Unsupported {
  public readonly brandTag = 'unsupported' as const;
}

export class FullySupported {
  public readonly brandTag = 'supported' as const;
}

export class Unlimited {
  public readonly brandTag = 'unlimited' as const;
  public readonly translationKey = 'features.supportLevels.unlimited';
}

export class LimitedByQuantity {
  public readonly brandTag = 'limited' as const;
  public readonly limit: number;
  public readonly translationKey?: string;

  constructor({ limit, translationKey }: { limit: number; translationKey?: string }) {
    this.limit = limit;
    this.translationKey = translationKey;
  }
}

export class ComingSoon {
  public readonly brandTag = 'comingSoon' as const;
  public readonly translationKey = 'features.supportLevels.comingSoon';
}

export class BillingCycleDependent {
  public readonly brandTag = 'billingCycleDependent' as const;
  public readonly support: Record<
    BillingCycle.Monthly | BillingCycle.Yearly,
    LimitedByQuantity | Unlimited | Unsupported | FullySupported | ComingSoon
  >;

  constructor(
    support: Record<
      BillingCycle.Monthly | BillingCycle.Yearly,
      LimitedByQuantity | Unlimited | Unsupported | FullySupported | ComingSoon
    >,
  ) {
    this.support = support;
  }
}

export type PlanFeatureLevelSupport =
  | Unsupported
  | FullySupported
  | Unlimited
  | LimitedByQuantity
  | ComingSoon
  | BillingCycleDependent;
